import { VREditorSubPanel } from './subpanel.js';
import { FieldLabel, IconSelect, ColorPicker, Switch, ActionSelect } from 'ca-ui';
import { VRHotspot } from '../ver-assets/hotspots.js';

export class VREditorHotspotPanel extends VREditorSubPanel {
  constructor (vr, editor) {
    super(vr, editor, {
      id: 'hotspots',
      name: 'Hotspots',
      instructions: 'Select a hotspot to edit, or add a new hotspot.',
      preview: false,
      assets: vr.assets.hotspots,
      assetSelectLabel: 'Type',
      allowAddAsset: true,
      addAssetButtonLabel: 'New Hotspot',
      onCreateAssetItem: function () {
      }
    });
  }

  initControls () {
    // Icon
    this.iconContainer = new FieldLabel({ label: 'Icon' });
    this.iconContainer.hide();
    super.append(this.iconContainer.el);

    this.iconSelect = new IconSelect({
      icon: 'search-plus',
      onSelect: function (icon, iconName) {
        this.selected.setIcon(icon, iconName);
      }.bind(this)
    });

    this.iconContainer.setField(this.iconSelect);

    // Color
    this.colorContainer = new FieldLabel({ label: 'Colour' });
    this.colorContainer.hide();
    super.append(this.colorContainer.el);

    this.colorPicker = new ColorPicker({
      color: 'red',
      onSelect: function (color) {
        this.selected.setColor(color);
      }.bind(this)
    });

    this.colorContainer.setField(this.colorPicker);


    this.hoverColorContainer = new FieldLabel({ label: 'Hover Colour' });
    this.hoverColorContainer.hide();
    super.append(this.hoverColorContainer.el);

    this.colorHoverPicker = new ColorPicker({
      color: 'red',
      onSelect: function (color) {
        this.selected.setHoverColor(color);
      }.bind(this)
    });

    this.hoverColorContainer.setField(this.colorHoverPicker);

    // Size
    this.sizeContainer = new FieldLabel({ label: 'Size' });
    this.sizeContainer.hide();
    super.append(this.sizeContainer.el);

    this.sizeSlider = $(
      '<input class="ca-vr_editorpanel-range" type="range" min="24" max="128" value="' +
        VRHotspot.defaultOptions.size +
        '"></input>'
    );

    this.sizeSlider.on(
      'input',
      function () {
        this.selected.setSize(this.sizeSlider.val());
      }.bind(this)
    );

    this.sizeContainer.setField(this.sizeSlider);

    // Pulse
    this.pulseContainer = new FieldLabel({ label: 'Pulse' });
    this.pulseContainer.hide();
    super.append(this.pulseContainer.el);

    this.pulseSwitch = new Switch();
    this.pulseSwitch.el.on(
      'input',
      function (e) {
        this.selected.setPulse($(e.target).prop('checked'));
      }.bind(this)
    );

    this.pulseContainer.setField(this.pulseSwitch);

    // Tooltip
    this.tooltipContainer = new FieldLabel({ label: 'Message' });
    this.tooltipContainer.hide();
    super.append(this.tooltipContainer.el);

    this.tooltipTextbox = $(`<input type="input" maxlength="100" value"${VRHotspot.defaultOptions.tooltip.label}" />`);
    this.tooltipTextbox.on(
      'input',
      function (e) {
        this.selected.setTooltip({label: this.tooltipTextbox.val()});
      }.bind(this)
    );
    super.append(this.tooltipTextbox);

    this.tooltipContainer.setField(this.tooltipTextbox);

    // Message Text Color
    this.messageTextColourContainer = new FieldLabel({ label: 'Message Colour' });
    this.messageTextColourContainer.hide();
    super.append(this.messageTextColourContainer.el);

    this.messageTextColourPicker = new ColorPicker({
      color: 'black',
      onSelect: function (color) {
        this.selected.setMessageTextColor(color);
      }.bind(this)
    });

    this.messageTextColourContainer.setField(this.messageTextColourPicker);

    // Message Background Color
    this.messageBgColourContainer = new FieldLabel({ label: 'Message Background Colour' });
    this.messageBgColourContainer.hide();
    super.append(this.messageBgColourContainer.el);

    this.messageBgColourPicker = new ColorPicker({
      color: 'white',
      onSelect: function (color) {
        this.selected.setMessageBackgroundColor(color);
      }.bind(this)
    });

    this.messageBgColourContainer.setField(this.messageBgColourPicker);

    // tooltip position
    this.tooltipPositionContainer = new FieldLabel({label: 'Message Position'});
    this.tooltipPositionContainer.hide();
    super.append(this.tooltipPositionContainer.el);

    this.tooltipPositionSelect = $(`
      <div class='ca-ver-editor_hotspot_tooltip-position'>
        <div class="ca-ver-editor_hotspot_tooltip-position_item">
          <input type='radio' id='tooltipPosLeft' name='tooltipPosition' value='left'>
          <label for='tooltipPosLeft'>Left</label>
        </div>
        <div class="ca-ver-editor_hotspot_tooltip-position_item">
          <input type='radio' id='tooltipPosTop' name='tooltipPosition' value='top'>
          <label for='tooltipPosTop'>Top</label>
        </div>
        <div class="ca-ver-editor_hotspot_tooltip-position_item">
          <input type='radio' id='tooltipPosRight' name='tooltipPosition' value='right'>
          <label for='tooltipPosRight'>Right</label>
        </div>
        <div class="ca-ver-editor_hotspot_tooltip-position_item">
          <input type='radio' id='tooltipPosBottom' name='tooltipPosition' value='bottom'>
          <label for='tooltipPosBottom'>Bottom</label>
        </div>
      </div>
    `);

    this.tooltipPositionSelect.on('change', function () {
      this.selected.setTooltipPosition($('input[name="tooltipPosition"]:checked').val());
    }.bind(this));

    super.append(this.tooltipPositionSelect);
    this.tooltipPositionContainer.setField(this.tooltipPositionSelect);

    // tooltip visibility

    this.tooltipVisibilityControlContainer = new FieldLabel({ label: 'Message Display' });
    this.tooltipVisibilityControlContainer.hide();
    super.append(this.tooltipVisibilityControlContainer.el);

    this.tooltipVisibilityControlSelect = $(`
    <div class='ca-ver-editor_hotspot_tooltip-visibility'>
      <div class="ca-ver-editor_hotspot_tooltip-visibility_item">
        <input type='radio' id='tooltipVisibilityHover' name='tooltipVisibility' value='hover'>
        <label for='tooltipVisibilityHover'>Hover</label>
      </div>
      <div class="ca-ver-editor_hotspot_tooltip-visibility_item">
        <input type='radio' id='tooltipVisibilityAlways' name='tooltipVisibility' value='always'>
        <label for='tooltipVisibilityAlways'>Always</label>
      </div>
      <div class="ca-ver-editor_hotspot_tooltip-visibility_item">
        <input type='radio' id='tooltipVisibilityNever' name='tooltipVisibility' value='never'>
        <label for='tooltipVisibilityNever'>Never</label>
      </div>
    </div>
    `);

    this.tooltipVisibilityControlSelect.on('change', function () {
      console.log('tooltip visibility type changed');
      this.selected.setTooltipDisplayType($('input[name="tooltipVisibility"]:checked').val());
    }.bind(this));

    // super.append(this.tooltipVisibilityControlSelect);
    this.tooltipVisibilityControlContainer.setField(this.tooltipVisibilityControlSelect);

    // Action
    this.actionContainer = new FieldLabel({ label: 'Action' });
    this.actionContainer.hide();
    this.actionContainer.el.addClass('ca-ver_editor_action-select');
    this.panel.append(this.actionContainer.el);

    this.actionSelect = new ActionSelect({
      icon: '',
      onSelect: function (actionType) {
        this.selected.setAction(actionType);
      }.bind(this)
    }, this.editor, this.vr, this);
    this.actionContainer.setField(this.actionSelect);
  }

  // override
  openPanel(){}

  setObject (obj, fireAssetChange) {
    super.setObject(obj, fireAssetChange);
    if (this.selected) {
      console.log(obj.getAction());
      this.sizeContainer.show();
      this.actionContainer.show();
      this.actionSelect.currentActionText.text(obj.getAction() !== undefined ? obj.getAction().type : 'None');
      this.actionSelect.setAction(obj.getAction());
      this.tooltipContainer.show();
      this.tooltipPositionContainer.show();
      this.tooltipVisibilityControlContainer.show();
      this.pulseContainer.show();
      this.iconContainer.show();
      this.hoverColorContainer.show();
      this.colorContainer.show();
      this.iconSelect.setIcon(this.selected.getIcon());
      this.colorPicker.setColor(this.selected.getColor());
      this.colorHoverPicker.setColor(this.selected.getHoverColor());
      this.messageBgColourContainer.show();
      this.messageTextColourContainer.show();
      this.messageBgColourPicker.setColor(this.selected.getMessageBackgroundColor());
      this.messageTextColourPicker.setColor(this.selected.getMessageTextColor());
      if (fireAssetChange !== false) { this.sizeSlider.val(this.selected.getSize()).trigger('input'); }
      this.pulseSwitch.setOn(this.selected.getPulse(), true);
      // if (fireAssetChange !== false) { this.tooltipTextbox.val(obj.getTooltipText()); }
      this.tooltipTextbox.val(this.selected.getTooltipText());
      $('[name="tooltipPosition"]').removeAttr('checked');
      $(`input[name=tooltipPosition][value="${this.selected.getTooltipPosition()}"]`).prop('checked', true);

      $('[name="tooltipVisibility"]').removeAttr('checked');
      $(`input[name=tooltipVisibility][value="${this.selected.getTooltipDisplayType()}"]`).prop('checked', true);
    } else {
      this.sizeContainer.hide();
      this.actionContainer.hide();
      this.tooltipContainer.hide();
      this.tooltipPositionContainer.hide();
      this.tooltipVisibilityControlContainer.hide();
      this.pulseContainer.hide();
      this.iconContainer.hide();
      this.colorContainer.hide();
      this.hoverColorContainer.hide();
      this.messageBgColourContainer.hide();
      this.messageTextColourContainer.hide();
    }
  }

  newObject () {
    return this.vr.addNewHotspot();
  }
}
